export enum Events {
  ALL = '*',
  ORDER_CONTINUE_BUTTON_CLICKED = 'orderContinueButtonClicked',
  ORDER_PLACED = 'orderPlaced',
  ORDER_WALLET_SEND_BUTTON_CLICKED = 'orderWalletSendButtonClicked',
  WIDGET_CONTINUE_BUTTON_CLICKED = 'widgetContinueButtonClicked'
}
